import { get } from 'lodash-es';
import initialState from '../../Store/initialState';

import * as types from './actionTypes';

let newState;

const settings = (state = initialState.get('plugins'), action) => {
  try {
    switch (action.type) {
      // UPDATE PLUGINS
      case types.UPDATE_PLUGINS: {
        newState = state.set(get(action, 'path'), get(action, 'data', []));
        return newState;
      }

      default:
        return state;
    }
  } catch (e) {
    console.log(e.stack);
    return state;
  }
};
export default settings;
